var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.462 3.853L9 1.5 6.538 3.853l.933.384.507.208L9 4.866l1.022-.42.507-.209.933-.384zm1.48-.083l-1.71.704L9 7.716 6.77 4.474 5.058 3.77l-1.308.708 1.497 1.564L9 9.959l3.752-3.917 1.498-1.564-1.308-.708zm-7.59 3.255L9 10.832l3.648-3.807-1.133 7.742h-5.03L5.353 7.025zm.863 8.289h5.57l1.336 1.186H4.88l1.336-1.186zm1.48-10.458L9 5.392l1.305-.536.007.01L9 6.772 7.69 4.866l.007-.01z",
    fill: "#3273FA"
  })));
}
export default __webpack_public_path__ + "static/svg/blue-tower.svg";
export { SvgBlueTower as ReactComponent };